// extracted by mini-css-extract-plugin
export default {"hobbies":"Hobbies_hobbies__kute8"};